import React from "react";
import "./GameOverComponent.css";

function GameOverComponent({ setOpenModal, gameEnd, country }) {
  let text;
  if (gameEnd.correctGuess) {
    text = "You are correct!  The flag belongs to: "
  } else {
    text = "You are incorrect, the flag belongs to: "
  }
  return (
    <div className="modalBackground">
      <div className="modalContainer">
        <div className="title">
          <h1>
            {text}
            <span className="countryName">{country.name}</span>
          </h1>

        </div>
        <div className="footer">
          <button
            onClick={() => {
              setOpenModal(false);
              window.location.reload();
            }}
            id="retryBtn"
          >
            New Game
          </button>
        </div>
      </div>
    </div>
  );
}

export default GameOverComponent;